import { useTranslation } from "react-i18next";
import { dayLabel, type Draft } from "@heraion/shared";

import type { UiTheme } from "../theme";
import { CopyOntoTray } from "./CopyOntoTray";

// «Copy to other days» (#336, 2B): the exercise menu's, for one exercise, and
// the selection bar's, for several. Every day but the open one, as chips; the
// button copies and closes. One tray for both, so they say the same words.
export function CopyToDaysTray({
  theme,
  draft,
  sIdx,
  what,
  onCopy,
  onCancel,
}: {
  theme: UiTheme;
  draft: Draft;
  sIdx: number;
  /** The exercise's name, or how many exercises. */
  what: string;
  onCopy: (days: number[]) => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  return (
    <CopyOntoTray
      theme={theme}
      question={t("editorV3.copyToDaysQuestion", { what, defaultValue: "Copy {{what}} to which days?" })}
      options={draft.sessions
        .map((_, i) => ({ key: String(i), label: `D${i + 1}`, a11yLabel: dayLabel(draft, i) }))
        .filter((o) => o.key !== String(sIdx))}
      footnote={t("editorV3.copyToDaysFootnote", {
        defaultValue: "Each day gets its own copy, at the end. A superset comes whole.",
      })}
      onCancel={onCancel}
      multiple={{
        confirmLabel: (count) =>
          count === 0
            ? t("editorV3.copyToDaysNone", { defaultValue: "Copy" })
            : t("editorV3.copyToDaysConfirm", { count, defaultValue: "Copy to {{count}} days" }),
        onConfirm: (keys) => onCopy(keys.map(Number)),
      }}
    />
  );
}
